import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/voting/importer/votingImporterActions';

export default importerReducers(actions);
